import getSignedUrl from "@warda/library-ui/contexts/AppCookiesContext/utils/getSignedUrl";
import parseIdToken from "@warda/library-ui/contexts/AppCookiesContext/utils/parseIdToken";
import { getSharePageAuthorization, getValidAccessCodeTokenForPageCode, removeAccessCodeTokenForPageCode, setAccessCodeTokenForPageCode, } from ".";
/**
 * Returns auth cookies helper even if instead of cookies you have chosen to keep the information in localstorage.
 * Also there is no token refresh mechanism.
 *
 * @returns authCookiesHelper
 */
export const SharePageAuthCookiesHelper = ({ pageCode, recheckLoginRequired, apiGatewayAccessWithAuthorizationHeader = true, }) => {
    const getIdToken = () => {
        const accessCodeToken = getValidAccessCodeTokenForPageCode(pageCode);
        if (accessCodeToken) {
            recheckLoginRequired();
        }
        return accessCodeToken;
    };
    const getIdTokenPayload = () => parseIdToken(getIdToken());
    const getRefreshToken = () => undefined;
    const getAuthorization = () => {
        const authorization = getSharePageAuthorization();
        if (!authorization) {
            recheckLoginRequired();
        }
        return authorization;
    };
    const shouldIdTokenBeRefreshed = (tokenRefreshThreshold) => {
        const checkIdToken = () => {
            if (!tokenRefreshThreshold)
                return !getValidAccessCodeTokenForPageCode(pageCode);
            const idTokenPayload = getIdTokenPayload();
            return (!idTokenPayload ||
                Date.now() + tokenRefreshThreshold > idTokenPayload.exp * 1000);
        };
        return checkIdToken();
    };
    const isFullyLogged = () => {
        return !!getValidAccessCodeTokenForPageCode(pageCode);
    };
    const isRefreshTokenPresent = () => {
        return false;
    };
    const setCookies = (authResponse) => {
        setAccessCodeTokenForPageCode({ pageCode, ...authResponse });
    };
    const removeAllCookies = () => {
        removeAccessCodeTokenForPageCode(pageCode);
    };
    const signUrl = (url) => getSignedUrl(url, getAuthorization(), apiGatewayAccessWithAuthorizationHeader);
    const isApiGatewayAccessWithAuthorizationHeader = () => apiGatewayAccessWithAuthorizationHeader;
    return {
        getIdToken,
        getRefreshToken,
        getAuthorization,
        getIdTokenPayload,
        isFullyLogged,
        shouldIdTokenBeRefreshed,
        isRefreshTokenPresent,
        setCookies,
        removeAllCookies,
        isApiGatewayAccessWithAuthorizationHeader,
        signUrl,
    };
};
